/* SessionListItem.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r28HPE%7Bpadding-top%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1Znuxb2ADO%7Bpadding-right%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW8HPE%7Bpadding-bottom%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Q2ADO%7Bpadding-left%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrulfZc%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fwxA57p2s%7Btext-align%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6d1Zr%3Ahover%7Bbackground-color%3Avar(--ds-surface-hovered%2C%23f0f1f2)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3gzVzLJNoT%3Aactive%7Bbackground-color%3Avar(--ds-surface-pressed%2C%23dddee1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruY9q9%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzjTy9%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6sumd%3Ahover%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3gzVzLXsxn%3Aactive%7Bbackground-color%3Avar(--ds-background-selected-pressed%2C%238fb8f6)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hhsrrNvrM%7Bborder-bottom-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3BoeID6wH8%7Bborder-bottom-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3XVgLM9r67%7Bborder-bottom-color%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { WidthObserver } from '@atlaskit/width-detector/width-observer';
import type { AgentSessionState } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { SessionAgent } from '../session-details/SessionAgent';
import { SessionContext, type SessionContextItem } from '../session-details/SessionContext';
import { SessionDetailsList } from '../session-details/SessionDetailsList';
import { SessionLastUpdated } from '../session-details/SessionLastUpdated';
import { SessionStatusIndicator } from '../session-details/SessionStatusIndicator';
import { SessionTitle } from '../session-details/SessionTitle';
import messages from './messages';
const COMPACT_WIDTH_BREAKPOINT = 480;
const styles = {
  item: "_1mT5xdRAKS",
  row: "_39xV02N91d _24h04i2Njc _0Of8r28HPE _1Znuxb2ADO _1wydGW8HPE _2Zuz6Q2ADO _0KLXrulfZc _1UtDYzy7kJ _2fwxA57p2s",
  interactiveRow: "_1eOmH6d1Zr _3gzVzLJNoT",
  selectedRow: "_0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _3gzVzLXsxn",
  divider: "_3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
  content: "_4ouGXIdnbC",
  trailing: "_3YEZNOdnbC"
};

/**
 * Presentation data accepted directly from normalized agent sessions.
 * Deliberately independent of Relay records and fetching hooks.
 */
export type SessionListSession = Readonly<{
  id: string;
  conversationChannel?: Readonly<{
    id?: string;
    name?: string;
    readStatus?: boolean | null;
  }>;
  /** Presentation fallback for sessions that do not have a conversation channel. */
  title?: string;
  state?: AgentSessionState | (string & {});
  /** Raw identity data interpreted by SessionAgent. */
  displayAgent?: Readonly<{
    id: string;
    name: string;
    isRovo?: boolean;
    agentId?: string;
    agentIdentityAccountId?: string;
    agentNamedId?: string;
  }>;
  /** Associated context data, in display priority order. */
  contexts?: readonly SessionContextItem[];
  /** Time of the latest state change, in epoch milliseconds. */
  lastStateChangeAt?: number;
  /** Caller-supplied transient activity, independent of attention and unread state. */
  isInProgress?: boolean;
}>;
export type SessionListItemProps = Readonly<{
  /** Normalized data for the session represented by this row. */
  session: SessionListSession;
  /** Enables one whole-row activation target. The caller owns the resulting action. */
  onActivate?: React.MouseEventHandler<HTMLButtonElement>;
  /** Whether the list should show a divider after this row. */
  hasDivider?: boolean;
  /** Whether this is the currently selected session. */
  isSelected?: boolean;
  testId?: string;
}>;

/** Responsive row presentation shared by SessionList and other session navigation surfaces. */
export const SessionListItem = ({
  session,
  onActivate,
  hasDivider,
  isSelected,
  testId
}: SessionListItemProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const [isCompact, setIsCompact] = useState(false);
  const handleWidthChange = useCallback((width: number) => {
    setIsCompact(width < COMPACT_WIDTH_BREAKPOINT);
  }, []);
  const title = (session.conversationChannel == null ? session.title?.trim() : session.conversationChannel.name?.trim()) || formatMessage(messages.sessionTitle);
  const requiresInput = session.state === 'INPUT_REQUIRED' || session.state === 'AUTH_REQUIRED';
  const isUnread = session.conversationChannel?.readStatus === false;
  const activationLabel = formatMessage(requiresInput ? messages.openSessionNeedsInputLabel : messages.openSessionLabel, {
    title
  });
  const contexts = session.contexts;
  const displayAgent = session.displayAgent?.isRovo ? undefined : session.displayAgent;
  const hasMetadata = Boolean(displayAgent || contexts?.length || session.lastStateChangeAt != null);
  const content = <Inline alignBlock="center" space="space.200" spread="space-between">
			<Stack grow="fill" space="space.050" xcss={styles.content}>
				<SessionTitle truncate>{title}</SessionTitle>
				{hasMetadata ? <SessionDetailsList>
						{displayAgent ? <SessionAgent agents={[displayAgent]} showNames iconSize={16} /> : null}
						{contexts?.length ? <SessionContext contexts={contexts} truncate /> : null}
						{session.lastStateChangeAt != null ? <SessionLastUpdated lastStateChangeAt={session.lastStateChangeAt} /> : null}
					</SessionDetailsList> : null}
			</Stack>
			{session.isInProgress || requiresInput || isUnread ? <Inline as="span" alignBlock="center" space="space.150" xcss={styles.trailing}>
					<SessionStatusIndicator isInProgress={session.isInProgress} requiresInput={requiresInput} requiresInputAppearance={isCompact ? 'icon' : 'badge'} isUnread={isUnread} />
				</Inline> : null}
		</Inline>;
  return <Box role="listitem" xcss={cx(styles.item, hasDivider && styles.divider)}>
			<WidthObserver setWidth={handleWidthChange} />
			{onActivate ? <Pressable xcss={cx(styles.row, styles.interactiveRow, isSelected && styles.selectedRow)} onClick={onActivate} aria-label={activationLabel} aria-current={isSelected ? 'page' : undefined} testId={testId}>
					{content}
				</Pressable> : <Box xcss={cx(styles.row, isSelected && styles.selectedRow)} testId={testId}>
					{content}
				</Box>}
		</Box>;
};